import { render, staticRenderFns } from "./Marina.vue?vue&type=template&id=03f13146&"
import script from "./Marina.vue?vue&type=script&lang=js&"
export * from "./Marina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports